export type PasswordRuleId =
  | 'minLength'
  | 'uppercase'
  | 'lowercase'
  | 'number'
  | 'special'

export interface PasswordRule {
  id: PasswordRuleId
  met: boolean
}

export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/

export function validatePassword(password: string): Array<PasswordRule> {
  return [
    { id: 'minLength', met: password.length >= 8 },
    { id: 'uppercase', met: /[A-Z]/.test(password) },
    { id: 'lowercase', met: /[a-z]/.test(password) },
    { id: 'number', met: /\d/.test(password) },
    { id: 'special', met: /[^A-Za-z0-9]/.test(password) },
  ]
}

export function isPasswordValid(password: string): boolean {
  return PASSWORD_REGEX.test(password)
}
